import { DisplayedCarouselProgramContext } from '@rhg/providers/displayed-carousel-program';
import { useContext } from 'react';

export function useDisplayedCarouselProgram() {
    return useContext(DisplayedCarouselProgramContext);
}
